import type { DocumentTemplateSummary, TemplateSource } from '../types/documentTemplates.types';

export const PLATFORM_OWNER_LABEL = 'Platform';
export const UNNAMED_DEALER_LABEL = 'Dealer-owned';
export const UNKNOWN_DEALER_LABEL = 'Unknown dealer';

export type OwnerChoice = { kind: 'platform' } | { kind: 'dealer'; dealerId: string };

export const canManageTemplate = (template: Pick<DocumentTemplateSummary, 'ownerDealerId'>, isInternal: boolean): boolean =>
  isInternal || template.ownerDealerId !== null;

export const ownerLabel = (
  template: Pick<DocumentTemplateSummary, 'ownerDealerId'>,
  dealerNames: ReadonlyMap<string, string>,
): string => {
  if (template.ownerDealerId === null) return PLATFORM_OWNER_LABEL;
  return dealerNames.get(template.ownerDealerId) ?? UNNAMED_DEALER_LABEL;
};

export const createOwnerPayload = (input: {
  isInternal: boolean;
  homeDealerId: string | null;
  choice: OwnerChoice | null;
}): string | null => {
  if (input.choice?.kind === 'dealer') return input.choice.dealerId;
  if (input.isInternal && input.choice?.kind === 'platform') return null;
  return input.homeDealerId;
};

export const provenanceLabel = (source: TemplateSource): string => {
  const name = source.templateName ?? 'a platform template';
  return source.versionNumber === null ? `Customised from ${name}` : `Customised from ${name} v${source.versionNumber}`;
};
